// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@ces/App/Store/Reducers";
import { xScreen } from "@ces/XDL/Utilities";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { injectCss } from "@insite/mobius/utilities";
import { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import MobiusStyledComponentProps from "@insite/mobius/utilities/MobiusStyledComponentProps";
import React, { FC } from "react";
import styled, { css } from "styled-components";

interface XngStickyProps {
    css?: StyledProp<XngStickyComponentProps>;
    stickyOffset?: string;
    stopBreakpoint?: "xs" | "sm" | "md" | "lg" | "xl";
    topValue?: number;
    [key: string]: any;
}

export type XngStickyComponentProps = MobiusStyledComponentProps<"div", XngStickyProps>;

const XngStickyWrapper = styled.div<XngStickyComponentProps>`
    position: sticky;
    z-index: 1;
    ${({ stopBreakpoint }) => css`
        ${xScreen("lt", stopBreakpoint || "sm")} {
            position: static;
        }
    `};
    @media print {
        position: static;
    }
    top: ${({ stickyOffset }: any) => stickyOffset || "unset"};

    ${injectCss}
`;

const XngSticky: FC<XngStickyProps> = props => {
    const stickyHeader = useAppSelector(state => (state as CustomAppState).xHeader.stickyHeader || "66");
    const topValue = props?.topValue;
    const [offset, setOffset] = React.useState(`${parseFloat(stickyHeader) + (topValue ?? 10)}px`);
    React.useEffect(() => {
        setOffset(`${parseFloat(stickyHeader) + (topValue ?? 10)}px`);
    }, [stickyHeader, topValue]);
    return <XngStickyWrapper {...props} stickyOffset={offset} />;
};

XngSticky.defaultProps = {
    className: "xng-sticky",
    stopBreakpoint: "sm",
};

export default XngSticky;
